import { createSelector, createSlice } from "@reduxjs/toolkit";

const payslipSlice = createSlice({
    name: "payslip",
    initialState: {
        ongoingOperation: false
    },
    reducers: {
        createPayslip: (state, action) => {
            state.ongoingOperation = true;
        },
        createdPayslip: (state, action) => {
            state.ongoingOperation = false;
        },
        listPayslip: () => { },
        detailPayslip: () => { },
        deletePayslip: () => { },
        getMyPayslip: () => { },
        getBulkDownloadLinks: () => { }
    }
});

export const {
    createPayslip,
    createdPayslip,
    getMyPayslip,
    listPayslip,
    detailPayslip,
    deletePayslip,
    getBulkDownloadLinks
} = payslipSlice.actions


export const selectOngoingOperation = createSelector(
    state => state.payslip,
    payslip => payslip.ongoingOperation
)

export default payslipSlice.reducer